import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  CardHeader,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ReportPopup from "./ReportPopup";
import ApiService from "../../services/categoryManagementApi";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import TableFilter from "../../components/shared/TableFilter";
import { DELIVERY_STATUS_OPTIONS, ORDER_STATUS_OPTIONS_LIST, QUERY_OPTIONS, STATUS_OPTIONS_LIST } from "../../utils/constants";

const { reportsAndAnalyticsApi } = ApiService;

const ReportsAndAnalytics = () => {
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [selectedReport, setSelectedReport] = useState("");

  const [inputDialogOpen, setInputDialogOpen] = useState(false);
  const [currentReportNeedsInput, setCurrentReportNeedsInput] = useState(false);


  const [period, setPeriod] = useState("");
  const [reportData, setReportData] = useState(null);
  const [open, setOpen] = useState(false);
  const [dealers, setDealers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [status, setStatus] = useState([]);

  const location = useLocation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const fromDateValue = fromDate?.slice(0, 10);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 10 }, (_, i) => currentYear - i);
  };

  const getLastDayOfMonth = (year, monthIndex) => {
    return new Date(year, monthIndex + 1, 0).getDate(); // 0 = last day of previous month
  };


  const periods = ["daily", "weekly", "monthly", "yearly"];
  const reportTypes = [
    { key: "dealerPerformance", label: "Dealer Performance" },
    { key: "driverPerformance", label: "Driver Performance" },
    // { key: "financial", label: "Financial Report" },
    { key: "revenue", label: "Revenue Report" },
    { key: "salesTrends", label: "Sales Trends" },
    { key: "refunds", label: "Refunds & Cancellations" },
    { key: "orderReports", label: "Order Reports" },
    { key: "userIssues", label: "User Issues & Support" },
    { key: "demographics", label: "Demographics" },
  ];

  useEffect(() => {
    if (selectedReport === "dealerPerformance" || selectedReport === "driverPerformance") {
      fetchDealers();
    }
  }, [selectedReport, searchKey]);

  const fetchDealers = async () => {
    try {
      if (selectedReport === "dealerPerformance") {
        const response = await reportsAndAnalyticsApi.getAllDealers({ searchItem: searchKey })

        setDealers(response?.data?.data?.result || []);
      }
      if (selectedReport === "driverPerformance") {
        const response = await reportsAndAnalyticsApi.getAllDrivers({ searchItem: searchKey })
        setDrivers(response?.data?.data || []);
      }

    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch dealers");
      console.error("Error fetching dealers:", error);
    }
  };
  const fetchReport = async () => {
    if (selectedReport === "dealerPerformance" && !selectedDealer) {
      toast.error("Please select a dealer.", { toastId: "error" });
      return;
    }

    if (selectedReport === "driverPerformance" && !selectedDriver) {
      toast.error("Please select a driver.", { toastId: "error" });
      return;
    }
    // if (selectedReport === "revenue" && !period) {
    //   toast.error("Please select a period.", { toastId: "error" });
    //   return;
    // }
    const requestBody = {
      type: selectedReport,
      id: selectedReport === "dealerPerformance"
        ? selectedDealer?._id
        : selectedReport === "driverPerformance"
          ? selectedDriver?._id
          : "",
      period: selectedReport === "revenue" ? period : "",
      status,
      startDate: fromDate,
      endDate: toDate
    };

    try {
      const response = await reportsAndAnalyticsApi.getUserReport(requestBody);
      setReportData(response?.data?.data?.result || {});
      setOpen(true);
    } catch (error) {
      toast.error(error?.response?.data?.message)
      console.error("Error fetching report:", error);
    }
  };

  useEffect(() => {
    if (location?.state?.dashboard == true) {
      setSelectedReport('revenue')
    }
  }, [])


  return (
    <Card sx={{ minHeight: "80vh", display: "flex", flexDirection: "column" }}>
      <Helmet>
        <title>Reports and Analytics</title>
      </Helmet>
      <CardHeader
        title="Reports and Analytics"
        titleTypographyProps={{ variant: "h4" }}
      />
      <CardContent >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>

          <TextField
            label="From Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: today,
            }}
            size="small"
            sx={{ marginRight: 2 }}
            value={fromDateValue}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                setFromDate(`${value}T00:00:00.000Z`);
                if (toDate && new Date(value) > new Date(toDate)) {
                  setToDate("");
                }
              } else {
                setFromDate("");
              }
            }}
          />


          <TextField
            label="To Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: today,
              min: fromDateValue || undefined,
            }}
            size="small"
            sx={{ marginRight: 2 }}
            value={toDate ? toDate.slice(0, 10) : ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                setToDate(`${value}T00:00:00.000Z`);;
              } else {
                setToDate("");
              }
            }}
          />

          <TableFilter data={selectedReport == "userIssues" ? QUERY_OPTIONS
            : selectedReport == "driverPerformance" ? DELIVERY_STATUS_OPTIONS
              : selectedReport == "orderReports" ? ORDER_STATUS_OPTIONS_LIST
                : STATUS_OPTIONS_LIST} value={status} setValue={setStatus} filterName="Status" />
        </Box>
        <Grid container spacing={3}>
          {/* Report Type Selection */}
          <Grid item xs={12}>
            {/* <Typography variant="h6" sx={{ mb: 2 }}>Select a Report</Typography> */}

            <br />
            <Grid container spacing={2}>
              {reportTypes.map((report) => {
                let subtitle = "";
                if (report.key === "driverPerformance" && selectedDriver) {
                  subtitle = selectedDriver.name;
                } else if (report.key === "dealerPerformance" && selectedDealer) {
                  subtitle = selectedDealer.businessName;
                } else if (report.key === "revenue" && period) {
                  subtitle = period.charAt(0).toUpperCase() + period.slice(1);
                }

                return (
                  <Grid item xs={12} sm={6} md={4} key={report.key}>
                    <Card
                      onClick={() => {
                        setStatus([]);
                        setSelectedReport(report.key);

                        if (report.key !== "dealerPerformance") {
                          setSelectedDealer(null);
                        }
                        if (report.key !== "driverPerformance") {
                          setSelectedDriver(null);
                        }
                        if (report.key !== "revenue") {
                          setPeriod("");
                        }

                        const needsInput = ["dealerPerformance", "driverPerformance", "revenue"].includes(report.key);
                        setCurrentReportNeedsInput(needsInput);
                        if (needsInput) setInputDialogOpen(true);
                      }}

                      sx={{
                        cursor: "pointer",
                        height: 120,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        padding: 2,
                        border: selectedReport === report.key ? "2px solid #1976d2" : "1px solid #ddd",
                        '&:hover': {
                          boxShadow: 6,
                          backgroundColor: '#f9f9f9',
                        },
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        {report.label}
                      </Typography>
                      {subtitle && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            mt: 1,
                            maxWidth: "90%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {subtitle}
                        </Typography>
                      )}
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

          </Grid>


          <Dialog open={inputDialogOpen} onClose={() => setInputDialogOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle>Select</DialogTitle>
            <DialogContent dividers>
              {selectedReport === "dealerPerformance" && (
                <Autocomplete
                  sx={{ mt: 2 }}
                  options={dealers}
                  getOptionLabel={(option) => option.businessName || ""}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  renderInput={(params) => <TextField {...params} label="Select Dealer" />}
                  onChange={(_, newValue) => setSelectedDealer(newValue || null)}
                />
              )}

              {selectedReport === "driverPerformance" && (
                <Autocomplete
                  sx={{ mt: 2 }}
                  options={drivers}
                  getOptionLabel={(option) => option.name || ""}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  renderInput={(params) => <TextField {...params} label="Select Driver" />}
                  onChange={(_, newValue) => setSelectedDriver(newValue || null)}
                />
              )}
              {selectedReport === "revenue" && (
                <Box>
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Select Period</InputLabel>
                    <Select
                      value={period}
                      label="Select Period"
                      onChange={(e) => {
                        setPeriod(e.target.value);
                        setSelectedYear("");
                        setSelectedMonth("");
                      }}
                    >
                      <MenuItem value="">Select Period</MenuItem>
                      <MenuItem value="yearly">Yearly</MenuItem>
                      <MenuItem value="monthly">Monthly</MenuItem>
                    </Select>
                  </FormControl>

                  {period === "yearly" && (
                    <FormControl fullWidth sx={{ mt: 2 }}>
                      <InputLabel>Select Year</InputLabel>
                      <Select
                        value={selectedYear}
                        onChange={(e) => {
                          const year = e.target.value;
                          setSelectedYear(year);

                          // Safe UTC-based date construction
                          const start = new Date(Date.UTC(year, 0, 1, 0, 0, 0)); // Jan 1
                          const end = new Date(Date.UTC(year, 11, 31, 23, 59, 59, 999)); // Dec 31

                          setFromDate(start.toISOString());
                          setToDate(end.toISOString());
                        }}

                      >
                        {getYears().map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {period === "monthly" && (
                    <>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Select Year</InputLabel>
                        <Select
                          value={selectedYear}
                          onChange={(e) => {
                            setSelectedYear(e.target.value);
                            setSelectedMonth("");
                          }}
                        >
                          {getYears().map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {selectedYear && (
                        <FormControl fullWidth sx={{ mt: 2 }}>
                          <InputLabel>Select Month</InputLabel>
                          <Select
                            value={selectedMonth}
                            onChange={(e) => {
                              const monthIndex = e.target.value;
                              setSelectedMonth(monthIndex);

                              const start = new Date(Date.UTC(selectedYear, monthIndex, 1, 0, 0, 0));
                              const end = new Date(Date.UTC(selectedYear, monthIndex + 1, 0, 23, 59, 59, 999));

                              setFromDate(start.toISOString());
                              setToDate(end.toISOString());
                            }}
                          >
                            {Array.from({ length: 12 }).map((_, index) => (
                              <MenuItem key={index} value={index}>
                                {new Date(0, index).toLocaleString("default", { month: "long" })}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </>
                  )}
                </Box>
              )}

            </DialogContent>
            <DialogActions>
              <Button onClick={() => setInputDialogOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>


          {/* Generate Report Button */}
          <Grid item xs={12}>
            <Box mt={4}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  py: 1.5,
                  fontSize: "1rem",
                  borderRadius: "8px",
                  textTransform: "none",
                  '&:hover': {
                    backgroundColor: "#155fa0",
                  },
                }}
                onClick={fetchReport}
                disabled={!selectedReport}
                type="submit"
              >
                Generate Report
              </Button>
            </Box>
          </Grid>

        </Grid>

        <ReportPopup
          open={open}
          onClose={() => setOpen(false)}
          reportType={selectedReport}
          reportData={reportData}
          fromDate={fromDate}
          toDate={toDate}
        />
      </CardContent>
    </Card>
  );
};

export default ReportsAndAnalytics;
